import { render } from "./ShowView.vue?vue&type=template&id=e83b6e86&scoped=true"
import script from "./ShowView.vue?vue&type=script&lang=js"
export * from "./ShowView.vue?vue&type=script&lang=js"

import "./ShowView.vue?vue&type=style&index=0&id=e83b6e86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e83b6e86"]])

export default __exports__